import { render, staticRenderFns } from "./section-banner.vue?vue&type=template&id=724ef2cf"
import script from "./section-banner.vue?vue&type=script&lang=js"
export * from "./section-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports